export default "__VITE_ASSET__BOVtyy1v__"